/*
 * header-nav-overflow.js — priority+ overflow for the icon-over-label desktop nav.
 *
 * Keeps the primary menu on a single line. Any top-level items that don't fit
 * are moved (in order) into the "Více" dropdown at the end of the row; when the
 * viewport grows again they move back. Desktop only (>= 990px); below that the
 * nav is hidden and the hamburger drawer takes over, so we no-op and restore.
 *
 * The "Více" toggle is a plain native <details> (NOT wrapped in Dawn's
 * <header-menu>): header-menu closes on focusout, and Safari blurs anchors back
 * to <body> on click, so the panel snapped shut before the link could navigate.
 * We manage close-on-outside-click / Escape here instead.
 */
(function () {
  var DESKTOP = '(min-width: 990px)';

  function initNav(nav) {
    if (!nav || nav.dataset.navOverflowInit === 'true') return;
    nav.dataset.navOverflowInit = 'true';

    var list = nav.querySelector('[data-nav-list]');
    var moreItem = nav.querySelector('[data-nav-more]');
    var panel = nav.querySelector('[data-nav-more-panel]');
    if (!list || !moreItem || !panel) return;

    var moreDetails = moreItem.querySelector('details');

    // Stable, ordered reference to the real top-level items (excludes "Více").
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > [data-nav-item]'));
    if (!items.length) return;

    var raf = null;
    var canReveal = false;

    function closeMore() {
      if (moreDetails) moreDetails.open = false;
    }

    // Native <details> only toggles on its own summary; add outside-click + Esc.
    document.addEventListener('click', function (e) {
      if (!moreDetails || !moreDetails.open) return;
      if (moreItem.contains(e.target)) return;
      moreDetails.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeMore();
    });

    function restoreAll() {
      items.forEach(function (li) { list.insertBefore(li, moreItem); });
      moreItem.hidden = true;
      closeMore();
    }

    function reveal() {
      // Held until fonts settle so the row is measured once, at final metrics,
      // and revealed without the untrimmed flash / font-reflow that Safari shows.
      if (!canReveal) return;
      nav.classList.add('is-nav-ready');
      requestAnimationFrame(function () { nav.classList.remove('nav-measuring'); });
    }

    function layout() {
      raf = null;

      // Freeze transitions while we reparent so moved icons don't color-fade.
      nav.classList.add('nav-measuring');

      // On small screens the inline nav is hidden — keep the DOM intact.
      if (!window.matchMedia(DESKTOP).matches || nav.offsetParent === null) {
        restoreAll();
        reveal();
        return;
      }

      restoreAll();

      // Everything fits on one line → no overflow menu needed.
      if (list.scrollWidth <= list.clientWidth + 1) {
        moreItem.hidden = true;
        reveal();
        return;
      }

      // Reveal the toggle, then peel items off the end until the row fits.
      moreItem.hidden = false;
      for (var i = items.length - 1; i >= 0; i--) {
        if (list.scrollWidth <= list.clientWidth + 1) break;
        panel.insertBefore(items[i], panel.firstChild);
      }

      reveal();
    }

    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(layout);
    }

    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);

    // Measure/trim once now (while hidden), then reveal after fonts resolve.
    // Failsafe timer covers a fonts.ready that never settles.
    var readyFired = false;
    function markReady() {
      if (readyFired) return;
      readyFired = true;
      canReveal = true;
      schedule();
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(markReady).catch(markReady);
      setTimeout(markReady, 1500);
    } else {
      markReady();
    }

    schedule();
  }

  function initAll() {
    document.querySelectorAll('[data-nav-overflow]').forEach(initNav);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor: header section re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
